import Vue from 'vue';
import VueRouter, { NavigationGuard, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';
import Index from './pages/index.vue';
import { Store, } from './store';

Vue.use(VueRouter);

const prefix = '/close-account';

const RequiresUserDetails: NavigationGuard = (to, _from, next) => {
	if (to.path === prefix) {
		next();
		return;
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingUserDetails) {
		next('/');
		return;
	}

	next();
};

const RequiresMoveOutDetails: NavigationGuard = (_to, _from, next) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingMoveOutDetails) {
		next('/');
		return;
	}

	next();
};

const RequiresForwardingAddress: NavigationGuard = (_to, _from, next) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasForwardingAddress) {
		next('/forwarding-address');
		return;
	}

	next();
};

export const Router = new VueRouter({
	base: prefix,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0, };
	},
	routes: [
		{
			path: `/`,
			component: {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				render: (c: any) => c('router-view'),
			},
			children: [
				{ path: '', component: Index, },
				{ path: `your-details`, name: 'YourDetails', component: () => import('./pages/your-details.vue').then((m) => m.default), },
				{ path: `move-out-date`, name: 'MoveOutDate', component: () => import('./pages/move-out-date.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMoveOutDetails,]), },
				{ path: `your-final-bill`, component: () => import('./pages/your-final-bill.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMoveOutDetails,]), },
				{ path: `forwarding-address`, component: () => import('./pages/forwarding-address.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMoveOutDetails,]), },
				{ path: `check-details`, component: () => import('./pages/check-details.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMoveOutDetails, RequiresForwardingAddress,]), },
				{ path: `success`, component: () => import('./pages/move-out-success.vue').then((m) => m.default), },
				{ path: `successful`, component: () => import('./pages/move-out-success.vue').then((m) => m.default), },
				{ path: `pay-final-bill/payment`, component: () => import('./pages/payment-detail.vue').then((m) => m.default), },
				{ path: `pay-final-bill/success`, component: () => import('./pages/payment-success.vue').then((m) => m.default), },
				{ path: `pay-final-bill/error/payment`, component: () => import('./pages/payment-failure.vue').then((m) => m.default), },
				{ path: `pay-final-bill/error/system`, component: () => import('./pages/system-failure.vue').then((m) => m.default), },
				{ path: `pay-final-bill/pending`, component: () => import('./pages/payment-pending.vue').then((m) => m.default), },
				{ path: `meter-upgrade`, component: () => import('./pages/meter-upgrade.vue').then((m) => m.default), },
			],
		},
	],
});

Router.afterEach((to) => {
	Store.commit.setActiveAlert(to.fullPath);
});
